import React from "react";
import "../../App.css";
import CrossingOutBiltyWise from "../CrossingOutBiltyWise";

function CrossingOutBiltyWisePage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("crossing-out-biltywise-report")){
    return;}
  return (
    <div className="page-mr">
      <CrossingOutBiltyWise sessionObject={sessionObject} />
    </div>
  );
}

export default CrossingOutBiltyWisePage;
